import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { getPlatformNative } from "shared/lib/get-platform-native"
import { Header } from "shared/ui/header/ui"
import { Main } from "widgets/main/ui"
import { Learning } from "widgets/learning/ui"
import { Process } from "widgets/process/ui"
// import { Teachers } from "widgets/teachers/ui"
import { Courses } from "widgets/courses/ui"
import { Feedback } from "widgets/feedback/ui"
import { Footer } from "widgets/footer/ui"
import { Popouts } from "widgets/app/popouts"
import { MobileMenuProvider } from "shared/contexts/mobile-menu-context"
import { AccessibilityProvider } from "shared/contexts/accessibility-context"
import { Seo } from 'shared/ui/seo';
import { SEO_PAGES } from 'shared/config/seo';
import { SeoPage } from 'widgets/seo-pages';
// import { HackathonBanner } from "widgets/hackathon-banner"

const _platform = getPlatformNative()
const EducationInfo = lazy(() => import('widgets/education-info').then(module => ({ default: module.EducationInfo })));

const HomePage = () => (
    <>
        <main>
        {/* <HackathonBanner /> */}
        <Main />
        <Courses />
        <Learning />
        <Process />
        <Feedback />
        {/* <Teachers /> */}
        </main>
        <Footer />
    </>
);

const AppContent = () => {
    const location = useLocation();
    const isHackathonPage = location.pathname === '/hackathon';

    return (
        <>
            <div className={`app ${_platform}`}>
                <Popouts />
                <Seo />
                {!isHackathonPage && <Header />}

                <div id="main-content" tabIndex={-1}>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/education-info" element={<><Suspense fallback={<p role="status" style={{ padding: '48px 24px' }}>Загружаем сведения об организации…</p>}><EducationInfo /></Suspense><Footer /></>} />
                    {SEO_PAGES.filter(page => page.kind !== 'home' && page.kind !== 'education').map(page => (
                        <Route key={page.path} path={page.path} element={<><SeoPage page={page} />{page.kind !== 'contacts' && <Footer />}</>} />
                    ))}
                    <Route path="*" element={<>
                        <main style={{ maxWidth: 900, margin: '0 auto', padding: '64px 24px' }}>
                            <h1>Страница не найдена</h1>
                            <p>Проверьте адрес или выберите направление обучения.</p>
                            <a href="/courses/">Перейти к курсам</a>
                            <a href="/">На главную</a>
                        </main>
                        <Footer />
                    </>} />
                </Routes>
                </div>
            </div>
        </>
    );
};

const App = () => {



    return (
        <AccessibilityProvider>
            <MobileMenuProvider>
                <Router>
                    <AppContent />
                </Router>
            </MobileMenuProvider>
        </AccessibilityProvider>
    )
}
export default App
